import JitsiMeetJS from "./lib-jitsi-meet.min";

export default JitsiMeetJS;
